import React from 'react';
import { connect } from 'react-redux';
import TeamIcon from '@material-ui/icons/Group';
import { getReducedEntityObjectList } from '../../../redux/reducers';
import constants from '../../../utils/constants';
import TeamEntityListItem from './TeamEntityListItem';
import EntitySearch from '../components/EntitiySearch';

const TeamSearch = connect(state => ({
  entities: getReducedEntityObjectList(state.entities.teams),
}))(props => (
  <EntitySearch
    {...{
      ...props,
      title: 'Teams',
      entityType: constants.entityType.team,
      EntityListItem: TeamEntityListItem,
      searches: [
        {
          search: 'name',
          leftIcon: <TeamIcon />,
          hintText: 'Team',
        },
      ],
    }}
  />
));

export default TeamSearch;
